export enum FeatureSubscriptionType {
  CareConnect = 'CareConnect',
}
